import {
  promoIsFixed,
  promoIsOther,
  promoIsPercentage,
  promoIsFree,
  type FixedPriceRebate,
  type PromotionItem,
  type PromotionGroup,
  type StandardizedPromotionLineItem,
  type PercentageRebate,
  type PromotionContent
} from '../Promotion.ts';

export function fromEcapiDto(
  promos: PromotionContent['promotionGroups']
): PromotionGroup[] {
  return promos.map((promo: any) => {
    const {
      name,
      products,
      promotions,
      description = '',
      subText = '',
      termsUrl = '',
      buyOptionButton = ''
    } = promo;
    return {
      name: name ?? '',
      description: description ?? '',
      subText: subText ?? '',
      products: products ?? [],
      termsUrl: termsUrl ?? '',
      promotions: (promotions ?? []).map(
        (promoLine: PromotionItem) => assemblePromotions(promoLine)!
      ),
      buyOptionButton: buyOptionButton ?? ''
    };
  });
}

function assemblePromotions(
  promotion: PromotionItem
): StandardizedPromotionLineItem | undefined {
  const { description = '', promotionType } = promotion;

  let modifier: StandardizedPromotionLineItem['modifier'];

  // handle the fact that the CMS sends numbers as a string number
  // and the structure is different across promo types
  switch (true) {
    case promoIsFixed(promotionType): {
      const { discountAmount } = promotion.promotionType as FixedPriceRebate;
      modifier = parseFloat(discountAmount);
      break;
    }
    case promoIsPercentage(promotionType): {
      const { percentageAmount } = promotion.promotionType as PercentageRebate;
      modifier = Number(percentageAmount);
      break;
    }
    case promoIsFree(promotionType): {
      break;
    }
    case promoIsOther(promotionType): {
      break;
    }
    default:
      break;
  }

  return {
    description,
    type: promotionType.type,
    modifier
  };
}
